<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card
      class="mt-3"
      v-else-if="!this.loading && !this.errormessage"
    >
      <div v-if="rowData.length > 0">
        <div class="d-none d-md-block">
          <el-table
            :data="rowData"
            header-row-class-name="text-danger"
            size="small"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
          >
            <el-table-column
              label="Day"
              property="CourseDay"
              class-name="d-none d-md-table-cell text-center"
              width="50px"
            />
            <el-table-column
              label="Title"
              property="Title"
              class-name="text-left"
            />
            <el-table-column
              label="Presenter"
              property="PresenterName"
              width="120px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Backup"
              property="BackupName"
              width="120px"
            />
            <el-table-column
              class-name="d-none d-md-table-cell"
              label="Location"
              property="PresentationLocation"
              width="120px"
            />
            <el-table-column
              label="Audience"
              class-name="d-none d-md-table-cell text-center"
              property="Audience"
              width="100px"
            />
            <el-table-column
              label="Notes"
              property="Notes"
              class-name="d-none d-md-table-cell text-center"
              width="100px"
            />
            <el-table-column
              label="Reference"
              property="CurriculumReference"
              class-name="d-none d-md-table-cell text-center"
              width="100px"
            />
          </el-table>
        </div>
        <div class="d-block d-md-none">
          <el-table
            :data="rowData"
            header-row-class-name="text-danger"
            size="small"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
          >
            <el-table-column
              label="Title"
              property="Title"
            />
            <el-table-column
              label="Presenter"
              property="PresenterName"
              width="120px"
            />
          </el-table>
        </div>
      </div>
      <div
        v-else
        class="text-center"
      >
        <p class="card-category">
          There are no staff members assigned to this course.
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import presentationApi from '@/services/api/presentation'
import oops from '@/components/_main/oops.vue'

export default {
  name: 'Presentation',
  components: {
    oops
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      loading: true,
      errormessage: null,
      tempHolding: null
    }
  },
  mounted () {
    presentationApi
      .list(this.$root.courseKey)
      .then(x => {
        this.rowData = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {}
}
</script>
